import React from 'react';
import PropTypes from 'prop-types';

export default function DefaultValueHint({ field, currentValue }) {
  // Option field defaults only preselect the dropdown; they are not applied as
  // a blank-value fallback, so "Defaults to: X" would be misleading.
  if (field.type === "OptionField") return null;
  if (!field.default_value) return null;
  if (currentValue && currentValue.length > 0) return null;

  return (
    <span className="text-muted text-size-small ml-5">
      {`Defaults to: ${field.default_value}`}
    </span>
  );
}

DefaultValueHint.propTypes = {
  field: PropTypes.object.isRequired,
  currentValue: PropTypes.string
}
